import { useRoleBasedView } from "hooks/useRoleBasedView";

export const useHasCommandPalette = (): {
  hasAdminPalette: boolean;
  hasCustomerPalette: boolean;
} => {
  const { isAdmin, isCustomer, isPersonalTaxUser } = useRoleBasedView();

  return {
    hasAdminPalette: Boolean(isAdmin),
    hasCustomerPalette: Boolean(isCustomer && !isPersonalTaxUser),
  };
};
